import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { MeloMondayProvider } from "@/context/MeloMondayContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PersistentPlayer from "@/components/PersistentPlayer";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Browse from "@/pages/Browse";
import AlbumDetail from "@/pages/AlbumDetail";
import ArtistProfile from "@/pages/ArtistProfile";
import Merch from "@/pages/Merch";
import Promotions from "@/pages/Promotions";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import LegalPage, { NotFound } from "@/pages/Legal";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import VerifyEmail from "@/pages/VerifyEmail";
import Manual from "@/pages/Manual";
import Roadmap from "@/pages/Roadmap";
import Chat from "@/pages/Chat";
import Releases from "@/pages/Releases";
import MeloMondayBanner from "@/components/MeloMondayBanner";

// Extracted to module scope so the object reference is stable across App
// re-renders — otherwise <Toaster /> re-mounts every render.
const TOAST_OPTIONS = {
  style: {
    background: "#121212",
    border: "1px solid #2A2A2A",
    color: "#F3F4F6",
    fontFamily: "JetBrains Mono, monospace",
    borderRadius: 0,
  },
};

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A] text-[#F3F4F6]">
      <BrowserRouter>
        <AuthProvider>
          <MeloMondayProvider>
          <PlayerProvider>
            <MeloMondayBanner />
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/browse" element={<Browse />} />
              <Route path="/album/:id" element={<AlbumDetail />} />
              <Route path="/artist/:id" element={<ArtistProfile />} />
              <Route path="/merch" element={<Merch />} />
              <Route path="/promotions" element={<Promotions />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/manual" element={<Manual />} />
              <Route path="/roadmap" element={<Roadmap />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/releases" element={<Releases />} />
              <Route path="/terms" element={<LegalPage which="terms" />} />
              <Route path="/privacy" element={<LegalPage which="privacy" />} />
              <Route path="/dmca" element={<LegalPage which="dmca" />} />
              <Route path="/contact" element={<LegalPage which="contact" />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
            <PersistentPlayer />
            <Toaster theme="dark" position="top-right" toastOptions={TOAST_OPTIONS} />
          </PlayerProvider>
          </MeloMondayProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
